<span class="d-block">{{ step1.getspan1 | translate }}</span>
<app-avis-initial-type [uid]="getUid()" [parentForm]="parentForm" [avisInitial]="rectificatif.avisInitial" [disabled]="disabled">
</app-avis-initial-type>
